<template>
  <div
    v-if="scenarioBoxTopic"
    class="scenario-box"
    v-html="scenarioBoxTopic.content"
  >
  </div>
</template>

<script>
import scenarioBoxMixin from '@/mixins/scenario-box';

export default {
  name: 'ScenarioBox',
  mixins: [scenarioBoxMixin],
  props: {
    flashcardId: {
      type: Number,
      default: null,
    },
  },
};
</script>

<style scoped>
.scenario-box >:first-child {
  margin-top: 0;
}

</style>
